import { Form, Input, Thumbnail } from '@bynder/design-system';
import { useCustomCSSEditor } from '../../../../../hooks/useCustomCSSEditor';
import { SettingsAccordion } from '../../SettingsAccordion';
import {
  IconPaddingLeftAndRight,
  IconPaddingTopAndBottom,
  IconRectangle,
} from '@bynder/icons';
import { BUTTON_MAX_PADDING, CSS_PROPERTIES } from '../../constants';
import { useActiveThemeset } from '../../../../../queries/themesets';
import { splitValueAndUnit } from '../../helpers';

const ButtonPadding = ({
  style,
  handleStyleChange,
}: {
  style: string;
  handleStyleChange: (value: string) => void;
}) => {
  const { getValueFromStyle, addValueToStyle } = useCustomCSSEditor(style);
  const { data: themeset } = useActiveThemeset();

  const handleCssPropertyChange = (newValue, property) => {
    const maxPadding = Math.min(
      Number(newValue.split('px')[0]),
      BUTTON_MAX_PADDING,
    ).toString();
    const newStyle = addValueToStyle(maxPadding + 'px', property);
    handleStyleChange(newStyle);
  };

  const themesetHorizontalPadding =
    themeset?.widgets.button.padding.horizontalPadding;
  const themesetVerticalPadding =
    themeset?.widgets.button.padding.verticalPadding;
  const [horizontalPadding] = splitValueAndUnit(
    getValueFromStyle(CSS_PROPERTIES.PADDING_LEFT),
  );
  const [verticalPadding] = splitValueAndUnit(
    getValueFromStyle(CSS_PROPERTIES.PADDING_TOP),
  );

  return (
    <SettingsAccordion
      noDivider
      thumbnail={<Thumbnail icon={<IconRectangle />} />}
      title="Layout"
    >
      <Form.Row>
        <Form.Group data-testid="buttonPaddingHorizontal">
          <Input
            type="number"
            icon={<IconPaddingLeftAndRight />}
            suffix="px"
            value={
              horizontalPadding
                ? String(horizontalPadding)
                : String(themesetHorizontalPadding)
            }
            onChange={value => {
              handleCssPropertyChange(value + 'px', [
                CSS_PROPERTIES.PADDING_LEFT,
                CSS_PROPERTIES.PADDING_RIGHT,
              ]);
            }}
          />
        </Form.Group>
        <Form.Group data-testid="buttonPaddingVertical">
          <Input
            type="number"
            icon={<IconPaddingTopAndBottom />}
            suffix="px"
            value={
              verticalPadding
                ? String(verticalPadding)
                : String(themesetVerticalPadding)
            }
            onChange={value => {
              handleCssPropertyChange(value + 'px', [
                CSS_PROPERTIES.PADDING_TOP,
                CSS_PROPERTIES.PADDING_BOTTOM,
              ]);
            }}
            placeholder={'0'}
          />
        </Form.Group>
      </Form.Row>
    </SettingsAccordion>
  );
};
export default ButtonPadding;
